import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { CodebookDto } from '../types/types';

const GET_SPORT_ACTIVITIES_QUERY = gql(`
query GetSportActivities {
  getSportActivities {
    value
    label
  }
}
`);

export function useGetSportActivities() {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  const { data, loading, error, refetch } = useQuery<{ getSportActivities: CodebookDto[] }>(GET_SPORT_ACTIVITIES_QUERY, {
  });

  const isLoading = !isInitialized || loading;

  return {
    loading: isLoading,
    error,
    refetch,
    sportActivities: data?.getSportActivities
  };
}
